import { useState } from "react";

import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import SEO from "../../components/SEO";

export default function PasswordGenerator() {

  const [password, setPassword] =
    useState("");

  const [length, setLength] =
    useState(12);

  const [includeUppercase,
    setIncludeUppercase] =
    useState(true);

  const [includeLowercase,
    setIncludeLowercase] =
    useState(true);

  const [includeNumbers,
    setIncludeNumbers] =
    useState(true);

  const [includeSymbols,
    setIncludeSymbols] =
    useState(true);

  const [strength,
    setStrength] =
    useState("");

  const generatePassword = () => {

    let chars = "";

    if (includeUppercase) {
      chars +=
        "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    }

    if (includeLowercase) {
      chars +=
        "abcdefghijklmnopqrstuvwxyz";
    }

    if (includeNumbers) {
      chars +=
        "0123456789";
    }

    if (includeSymbols) {
      chars +=
        "@#$%&*!?";
    }

    if (!chars) {
      return;
    }

    let pass = "";

    for (
      let i = 0;
      i < length;
      i++
    ) {

      pass += chars.charAt(
        Math.floor(
          Math.random() * chars.length
        )
      );
    }

    setPassword(pass);

    /* STRENGTH */

    if (length < 8) {
      setStrength("Weak");
    }

    else if (length < 14) {
      setStrength("Medium");
    }

    else {
      setStrength("Strong");
    }
  };

  const copyPassword = () => {

    navigator.clipboard.writeText(
      password
    );

    alert(
      "Password copied!"
    );
  };

  return (
    <>
      <SEO
        title="Secure Password Generator Online"
        description="Generate strong secure random passwords instantly with custom length, symbols, numbers, and uppercase options."
        keywords="password generator, secure password generator, random password generator, strong password"
        url="https://online-tools-center.vercel.app/password-generator"
      />

      <Navbar />

      <div className="container py-4">

        <div className="row justify-content-center">

          <div className="col-lg-9">

            <div className="card shadow-lg border-0 rounded-4 p-4">

              {/* HERO */}

              <div className="text-center mb-4">

                <h1 className="fw-bold mb-3">
                  Password Generator
                </h1>

                <p className="text-muted">
                  Generate strong secure
                  random passwords instantly
                  for better online security.
                </p>

                <div className="d-flex flex-wrap justify-content-center gap-2 mt-3">

                  <span className="badge bg-light text-dark p-2">
                    ✓ Strong Passwords
                  </span>

                  <span className="badge bg-light text-dark p-2">
                    ✓ Custom Length
                  </span>

                  <span className="badge bg-light text-dark p-2">
                    ✓ Symbols & Numbers
                  </span>

                  <span className="badge bg-light text-dark p-2">
                    ✓ Free Tool
                  </span>

                </div>

              </div>

              {/* MAIN SECTION */}

              <div className="row g-4">

                {/* LEFT */}

                <div className="col-md-6">

                  <label className="fw-semibold mb-2">
                    Password Length
                  </label>

                  <input
                    type="range"
                    min="6"
                    max="32"
                    value={length}
                    className="form-range"
                    onChange={(e) =>
                      setLength(
                        e.target.value
                      )
                    }
                  />

                  <div className="mb-3">

                    Length:
                    {" "}
                    <strong>
                      {length}
                    </strong>

                  </div>

                  {/* OPTIONS */}

                  <div className="form-check mb-2">

                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={includeUppercase}
                      onChange={() =>
                        setIncludeUppercase(
                          !includeUppercase
                        )
                      }
                    />

                    <label className="form-check-label">
                      Uppercase Letters
                    </label>

                  </div>

                  <div className="form-check mb-2">

                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={includeLowercase}
                      onChange={() =>
                        setIncludeLowercase(
                          !includeLowercase
                        )
                      }
                    />

                    <label className="form-check-label">
                      Lowercase Letters
                    </label>

                  </div>

                  <div className="form-check mb-2">

                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={includeNumbers}
                      onChange={() =>
                        setIncludeNumbers(
                          !includeNumbers
                        )
                      }
                    />

                    <label className="form-check-label">
                      Numbers
                    </label>

                  </div>

                  <div className="form-check mb-4">

                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={includeSymbols}
                      onChange={() =>
                        setIncludeSymbols(
                          !includeSymbols
                        )
                      }
                    />

                    <label className="form-check-label">
                      Symbols
                    </label>

                  </div>

                  <button
                    className="btn btn-primary w-100 py-2 fw-semibold"
                    onClick={generatePassword}
                  >
                    Generate Password
                  </button>

                </div>

                {/* RIGHT */}

                <div className="col-md-6">

                  <div className="bg-light rounded-4 p-4 h-100">

                    <h4 className="fw-bold mb-3">
                      Generated Password
                    </h4>

                    {password ? (

                      <>

                        <div className="border rounded-3 p-3 bg-white mb-3">

                          <code
                            style={{
                              wordBreak:
                                "break-all",
                            }}
                          >
                            {password}
                          </code>

                        </div>

                        <div className="mb-3">

                          Strength:
                          {" "}

                          <strong>

                            {strength}

                          </strong>

                        </div>

                        <button
                          className="btn btn-dark"
                          onClick={
                            copyPassword
                          }
                        >
                          Copy Password
                        </button>

                      </>

                    ) : (

                      <p className="text-muted">
                        Generate a password
                        to see result here.
                      </p>

                    )}

                  </div>

                </div>

              </div>

            </div>

            {/* SEO CONTENT */}

          {/* SEO CONTENT */}
<div className="mt-5">

  <h2 className="fw-bold mb-3">What is a Password Generator?</h2>
  <p>
    A password generator is an online tool that creates strong, random passwords
    using a combination of uppercase letters, lowercase letters, numbers, and
    special symbols. Unlike passwords you create manually — which tend to follow
    predictable patterns like names, birthdays, or common words — a randomly
    generated password has no pattern and is extremely difficult for hackers or
    automated programs to guess. Our password generator lets you customize the
    length and character types so you can create a password that meets the
    specific requirements of any website or application.
  </p>

  <h2 className="fw-bold mt-5 mb-3">Why Strong Passwords Matter</h2>
  <p>
    Weak passwords are one of the leading causes of account breaches and identity
    theft. Cybercriminals use techniques like brute force attacks, where software
    automatically tries millions of password combinations per second, and
    dictionary attacks, where common words and phrases are tested systematically.
    A short or simple password like "john123" can be cracked in under a second
    by modern attack tools. A randomly generated 16-character password with
    mixed character types, on the other hand, would take billions of years to
    crack using the same methods. Using a strong unique password for every account
    is the single most effective step you can take to protect your online security.
  </p>

  <h2 className="fw-bold mt-5 mb-3">How to Use This Password Generator</h2>
  <ol>
    <li className="mb-2">
      <strong>Set the password length</strong> using the slider. A minimum of
      12 characters is recommended for most accounts. For banking or email
      accounts, use 16 characters or more.
    </li>
    <li className="mb-2">
      <strong>Select character types</strong> — check or uncheck Uppercase
      Letters, Lowercase Letters, Numbers, and Symbols based on what the
      website allows. Including all four types produces the strongest passwords.
    </li>
    <li className="mb-2">
      <strong>Click Generate Password</strong> — a new random password appears
      instantly in the result box along with a strength indicator.
    </li>
    <li className="mb-2">
      <strong>Click Copy Password</strong> to copy it to your clipboard, then
      paste it directly into the password field of the site you are signing
      up for.
    </li>
    <li className="mb-2">
      <strong>Regenerate anytime</strong> — click the button again to get a
      completely different password. Each click produces a brand new result.
    </li>
  </ol>

  <h2 className="fw-bold mt-5 mb-3">Understanding Password Strength</h2>
  <p>
    Password strength depends on two main factors: length and character variety.
    Passwords under 8 characters are considered weak regardless of what
    characters they contain. Passwords between 8 and 13 characters with mixed
    types are medium strength — acceptable for low-risk accounts. Passwords of
    14 characters or more with uppercase, lowercase, numbers, and symbols are
    considered strong and are suitable for email, banking, social media, and
    any account that stores sensitive information. Our tool shows you the
    strength rating automatically so you can adjust the settings to meet your
    security needs.
  </p>

  <h2 className="fw-bold mt-5 mb-3">Tips for Managing Your Passwords Safely</h2>
  <p>
    Generating a strong password is only the first step. Keeping it safe is
    equally important. Never reuse the same password across multiple websites —
    if one site gets breached, attackers will try your password on every other
    platform. Do not store passwords in a plain text file or a notes app on
    your phone. Instead, use a dedicated password manager like Bitwarden,
    1Password, or the built-in password manager in your browser to store and
    autofill passwords securely. Enable two-factor authentication (2FA) wherever
    possible as an extra layer of protection even if your password is compromised.
    Change passwords for important accounts every 6 to 12 months, and immediately
    change any password for an account that has been involved in a known data
    breach.
  </p>

  <h2 className="fw-bold mt-5 mb-3">Frequently Asked Questions</h2>

  <div className="mb-4">
    <h5>Is this password generator safe to use?</h5>
    <p>
      Yes, completely safe. All passwords are generated entirely inside your
      browser using JavaScript. No password is ever sent to any server, stored
      in a database, or logged anywhere. The moment you close or refresh the
      page, the generated password is gone — only you have it.
    </p>
  </div>

  <div className="mb-4">
    <h5>What makes a password strong?</h5>
    <p>
      A strong password is long (at least 12–16 characters), random (no words,
      names, or patterns), and uses a mix of uppercase letters, lowercase
      letters, numbers, and special symbols like @, #, $, and !. It should
      be unique — not used on any other account — and should not contain
      personal information like your name, date of birth, or phone number.
    </p>
  </div>

  <div className="mb-4">
    <h5>How long should my password be?</h5>
    <p>
      For most online accounts, a password of 12 characters is the minimum
      recommended length. For high-value accounts like email, banking, or work
      systems, use at least 16 characters. Longer passwords are exponentially
      harder to crack — a 16-character password is not just slightly harder
      than an 8-character one, it is trillions of times harder to brute force.
    </p>
  </div>

  <div className="mb-4">
    <h5>Should I use symbols in my password?</h5>
    <p>
      Yes, whenever the website allows it. Adding symbols dramatically increases
      the number of possible password combinations. For example, a 12-character
      password using only lowercase letters has about 95 billion possible
      combinations. Adding uppercase, numbers, and symbols increases that to
      over 475 trillion combinations, making brute force attacks practically
      impossible.
    </p>
  </div>

  <div className="mb-4">
    <h5>Is this tool free and unlimited?</h5>
    <p>
      Yes. You can generate as many passwords as you need with no limits, no
      account required, and no charges. The tool works on all devices including
      mobile, tablet, and desktop.
    </p>
  </div>

  {/* RELATED TOOLS */}
  <div className="mt-5 p-4 bg-light rounded-4">
    <h3 className="fw-bold mb-3">Related Tools</h3>
    <div className="d-flex flex-wrap gap-3">
      <a href="/qr-generator" className="btn btn-outline-primary">QR Generator</a>
      <a href="/json-formatter" className="btn btn-outline-primary">JSON Formatter</a>
      <a href="/age-calculator" className="btn btn-outline-primary">Age Calculator</a>
    </div>
  </div>

</div>

          </div>

        </div>

      </div>

      <Footer />

    </>
  );
}